import { useState } from 'react';
import { useFile } from '../../context/AppContext.jsx';
import { useChangeFeature } from '../../hooks/useChangeFeature.js';

export default function ChangeFeatureSection() {
  const { currentFeatures, nodes } = useFile();
  const { applyFeatureChange } = useChangeFeature();
  const [isExpanded, setIsExpanded] = useState(false);
  const [scope, setScope] = useState('selected');
  const [newFeatureIndex, setNewFeatureIndex] = useState(0);
  const [transformMode, setTransformMode] = useState('absolute');
  const [selectedNode, setSelectedNode] = useState('');

  const handleApply = () => {
    const nodeIndex = scope === 'node' ? parseInt(selectedNode) : null;
    applyFeatureChange(scope, newFeatureIndex, transformMode, nodeIndex);
  };

  return (
    <section className="mb-6">
      <h2
        className="text-lg font-semibold mb-4 pb-2 border-b-2 border-border cursor-pointer flex items-center justify-between hover:text-primary transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="flex items-center gap-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
          <span>Change Feature</span>
        </span>
        <span className={`text-base text-text-secondary transition-transform ${isExpanded ? '' : '-rotate-90'}`}>▼</span>
      </h2>

      {isExpanded && (
        <>
          <p className="text-text-secondary text-sm mb-4">Change which feature waypoints reference</p>

          <div className="space-y-3">
            <div>
              <label className="text-sm font-semibold text-text-secondary mb-1 block">Apply to:</label>
              <select
                value={scope}
                onChange={(e) => {
                  setScope(e.target.value);
                  setSelectedNode('');
                }}
                className="w-full bg-bg-tertiary border border-border rounded px-2 py-1.5 text-text-primary text-sm"
              >
                <option value="selected">Selected Waypoint</option>
                <option value="node">Node</option>
                <option value="all">All Waypoints</option>
              </select>
            </div>

            {scope === 'node' && (
              <div>
                <label className="text-sm font-semibold text-text-secondary mb-1 block">Node:</label>
                <select
                  value={selectedNode}
                  onChange={(e) => setSelectedNode(e.target.value)}
                  className="w-full bg-bg-tertiary border border-border rounded px-2 py-1.5 text-text-primary text-sm"
                >
                  <option value="">Select a node...</option>
                  {nodes.map((node, index) => (
                    <option key={index} value={index}>
                      {node.type} - {node.feature} ({node.indices.length} waypoints)
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label className="text-sm font-semibold text-text-secondary mb-1 block">New Feature:</label>
              <select
                value={newFeatureIndex}
                onChange={(e) => setNewFeatureIndex(parseInt(e.target.value))}
                className="w-full bg-bg-tertiary border border-border rounded px-2 py-1.5 text-text-primary text-sm"
              >
                {currentFeatures.map((feature, index) => (
                  <option key={index} value={index}>
                    {feature.name || `Feature ${index + 1}`}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm font-semibold text-text-secondary mb-1 block">Transform Mode:</label>
              <select
                value={transformMode}
                onChange={(e) => setTransformMode(e.target.value)}
                className="w-full bg-bg-tertiary border border-border rounded px-2 py-1.5 text-text-primary text-sm"
              >
                <option value="absolute">Keep Absolute Position</option>
                <option value="relative">Move Relative to New Feature</option>
              </select>
            </div>

            <button
              onClick={handleApply}
              className="w-full bg-primary text-white px-3 py-1.5 text-sm rounded hover:bg-blue-600 transition-colors"
            >
              Apply Feature Change
            </button>
          </div>
        </>
      )}
    </section>
  );
}
